import { render, staticRenderFns } from "./File.vue?vue&type=template&id=1e0e7d84&scoped=true"
import script from "./File.vue?vue&type=script&lang=js"
export * from "./File.vue?vue&type=script&lang=js"
import style0 from "./File.vue?vue&type=style&index=0&id=1e0e7d84&prod&lang=scss&scoped=true"
import style1 from "./File.vue?vue&type=style&index=1&id=1e0e7d84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0e7d84",
  null
  
)

export default component.exports